import React from 'react';

const items = [
  { icon: '⛏', label: 'Mining & Underground Ops' },
  { icon: '🛢', label: 'Oil & Gas Supply Chain' },
  { icon: '📡', label: 'Telecommunications' },
  { icon: '🏗', label: 'Industrial Infrastructure' },
  { icon: '🔐', label: 'Enterprise Security' },
  { icon: '☁️', label: 'Cloud & IoT Systems' },
];

export default function TrustBar() {
  return (
    <div style={{
      padding: '30px 5%',
      background: 'var(--navy-mid)',
      borderTop: '1px solid rgba(0,180,216,0.08)',
      borderBottom: '1px solid rgba(0,180,216,0.08)',
    }}>
      <div style={{
        display: 'flex', alignItems: 'center', gap: '2rem', flexWrap: 'wrap',
      }}>
        <div style={{
          fontSize: '0.72rem', fontWeight: 700, letterSpacing: '1.5px',
          textTransform: 'uppercase', color: 'var(--slate)', whiteSpace: 'nowrap',
        }}>
          Sector Experience
        </div>
        <div style={{ width: 1, height: 24, background: 'rgba(0,180,216,0.2)', flexShrink: 0 }}/>
        <div style={{ display: 'flex', gap: '1.8rem', flexWrap: 'wrap', alignItems: 'center' }}>
          {items.map((item, i) => (
            <div key={i} style={{
              display: 'flex', alignItems: 'center', gap: '0.4rem',
              fontSize: '0.83rem', fontWeight: 500,
              color: 'var(--slate)', whiteSpace: 'nowrap',
            }}>
              <span>{item.icon}</span> {item.label}
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
